import * as yup from 'yup';
import { gstCheck, panCheck } from '../../common/regex';

export const validationSchema = yup.object().shape({
  gstNumber: yup
    .string()
    .matches(
      gstCheck,
      'Invalid GST number format'
    ) // Matches GST format
    .required('GST number is required'),
  
    legalName: yup
    .string()
    .required('Organisation name is required'),

    businessAddress: yup
    .string()
    .required('Address is required'),

    panNumber: yup
    .string()
    .matches(
      panCheck,
      'Invalid PAN number format'
    ) // Matches PAN format
    .required('PAN number is required'),

    msmeIncNumber: yup
    .string()
    .required('Incorporation Name / MSME is required'),
});
